import request from '@/utils/request'

//油罐列表
export function oilTankList(query) {
  return request({
    url: '/api/station/listOilTank',
    method: 'post',
    params: query
  })
}

//国标
export function getProdFormat(query) {
  return request({
    url: '/api/station/listProdFormat',
    method: 'post',
    params: query
  })
}

//设置预警值
export function setWarningVal(query) {
  return request({
    url: '/api/station/setOilTankThreshold',
    method: 'post',
    params: query
  })
}

//设置油品
export function setOilTank(query) {
  return request({
    url: '/api/station/setOilTank',
    method: 'post',
    params: query
  })
}

//进油记录
export function getInOilRecord(query) {
  return request({
    url: '/api/station/listOilTankRecord',
    method: 'post',
    params: query
  })
}


